/* eslint-disable indent */
/* eslint-disable no-undef */

import { html, LitElement } from 'lit';
import './header';
import './information';
import './prize';
import './form';
import './abrules';
import './footer';
import './moreInfo';
import sha256 from 'js-sha256';
import getCropped from './cropper';
import campaignsConfig from './campaigns.config.json';

function etLocalToUTCMs(isoLocalStr, timezone) {
  const msIfUTC = Date.parse(isoLocalStr + 'Z');
  const tzStr = new Date(msIfUTC).toLocaleString('sv-SE', { timeZone: timezone });
  const tzMs = Date.parse(tzStr.replace(' ', 'T') + 'Z');
  return msIfUTC + (msIfUTC - tzMs);
}

function resolveActivePeriod({ timezone, periods }) {
  const now = Date.now();
  for (const period of periods) {
    const open = etLocalToUTCMs(period.open, timezone);
    const close = etLocalToUTCMs(period.close, timezone);
    if (now >= open && now < close) return period;
  }
  return null;
}

function resolveCampaignEnded({ timezone, periods }) {
  const finalPeriod = periods.find((period) => period.label === 'Period 4');
  if (!finalPeriod) return false;
  return Date.now() >= etLocalToUTCMs(finalPeriod.close, timezone);
}

function msUntilNextChange({ timezone, periods }) {
  const now = Date.now();
  let next = null;
  for (const period of periods) {
    for (const boundary of [period.open, period.close]) {
      const diff = etLocalToUTCMs(boundary, timezone) - now;
      if (diff > 0 && (next === null || diff < next)) next = diff;
    }
  }
  return next;
}

let imgData = '';

export class LateralGallery extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    contentStrapi: { type: Object },
    basepath: { type: String },
    env: { type: String },
    progId: { type: String },
    dataEntries: { type: Object },
    view: { type: Number },
    userId: { type: String },
    email: { type: String },
    _activePeriod: { state: true },
    _campaignEnded: { state: true }
  };

  constructor() {
    super();
    this.name = 'webcomponent';
    this.contentStrapi = {};
    this.basepath = '';
    this.imageHeight = 0;
    this._resizeObserver = null;
    this.dataEntries = {};
    this.progId = '';
    this.env = 'prod';
    this.userId = '';
    this.email = '';
    this.view = 11;
    this.selectReceipt = {
      name: 'upload_receipt',
      programId: '',
      idComponent: '',
      maxSizeImg: 100,
      type: 'imagen'
    };

    this._activePeriod = null;
    this._campaignEnded = false;
    this._changeTimeout = null;
    this._safetyInterval = null;

    window.addEventListener(
      'get-data',
      (e) => {
        const { data_get } = e.detail;

        this.dataEntries = data_get;

        const pdfImg = document.querySelector('.pdf-preview');

        this.email = data_get.email;

        if (!pdfImg && imgData === '') {
          this.handleSubmit();
        }
      },
      false
    );
  }

  handleSubmit() {
    const { dataEntries } = this;

    this.call(dataEntries, `https://api.helloprobability.io/submission/${this.env}`).then((res) => {
      $('header-webcomponent').hide();
      $('information-webcomponent').hide();
      $('form-webcomponent').hide();
      $('prize-webcomponent').hide();
      $('moreinfo-webcomponent').hide();
      $('.social').hide();

      if (res.statusCode === 200) {
        this.userId = res.data.id;

        const emailHash = sha256(this.email);

        const pixelUrl = `https://login.dotomi.com/profile/visit/px/1_0?dtm_cid=82606&dtm_cmagic=bfcf79&dtm_fid=102&dtm_promo_id=201&dtm_email_hash=${emailHash}&dtm_user_id=${this.userId}`;

        const img = document.createElement('img');
        img.src = pixelUrl;
        img.style.display = 'none ';
        img.width = 1;
        img.height = 1;
        img.alt = '';

        document.body.appendChild(img);
        console.log('Pixel enviado:', pixelUrl);

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'form-submit',
            'form-submit': true,
            'field-error': ''
          });
        }

        setTimeout(() => {
          this.view = 1;

          setTimeout(() => {
            const elmnt = document.querySelector('.thank-you');
            elmnt.scrollIntoView({ block: 'end' });
          }, 300);
        }, 100);
      } else {
        this.view = 2;
        console.log('error...');

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'form-submit',
            'form-submit': false,
            'field-error': `${res.error.detail}`
          });
        }

        setTimeout(() => {
          $('.rh1').text(res.error.detail);

          setTimeout(() => {
            const elmnt = document.querySelector('.thank-you');
            elmnt.scrollIntoView({ block: 'end' });
          }, 300);
        }, 100);
        console.log('error');
      }
    });

    this.requestUpdate();

    return true;
  }

  async call(payload, url) {
    const _response = await fetch(`${url}/${this.progId}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' }
    });

    const response = _response.json();

    return response;
  }

  bonusEntry(social) {
    const { env, userId } = this;

    const dataBonus = {
      _env: env,
      _program: '69d7be589a19c96efd8325b2',
      _entry_id: userId,
      _socialNetwork: social,
      _email: this.email
    };

    fetch('https://api.helloprobability.io/service/bonus-entries-network', {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(dataBonus)
    });
  }

  async connectedCallback() {
    super.connectedCallback();

    // Load data from Strapi
    this.contentStrapi = strapiData || '';

    const config = campaignsConfig.universalform;
    this._activePeriod = resolveActivePeriod(config);
    this._campaignEnded = resolveCampaignEnded(config);
    this._scheduleNextChange(config);

    this._safetyInterval = setInterval(() => {
      const resolved = resolveActivePeriod(config);
      if (resolved?.formId !== this._activePeriod?.formId) this._activePeriod = resolved;
      const ended = resolveCampaignEnded(config);
      if (ended !== this._campaignEnded) this._campaignEnded = ended;
    }, 30000);

    const btn = setInterval(() => {
      if ($('#btn-next').length > 0) {
        $('#state').select2({
          placeholder: 'Select state',
          allowClear: true,
          minimumResultsForSearch: -1
        });

        $('#btn-next').on('click', (e) => {
          e.preventDefault();
          const isOptinChecked = $('#optin_field').is(':checked');
          if (isOptinChecked) {
            $('#error-check-optin_field p')
              .get(0)
              .style.setProperty('color', '#FFFFFF', 'important');
            $('#error-check-optin_field p a')
              .get(0)
              .style.setProperty('color', '#FFFFFF', 'important');
          } else {
            $('#error-check-optin_field p')
              .get(0)
              .style.setProperty('color', '#D7000A', 'important');
            $('#error-check-optin_field p a')
              .get(0)
              .style.setProperty('color', '#D7000A', 'important');
          }
        });

        clearInterval(btn);
      }
    }, 100);

    const validView3 = setInterval(() => {
      if ($('.upload-text').length > 0) {
        $('.upload-text').html(
          '<div class="upload-container"><span class="upload-text__title">UPLOAD RECEIPT</span><span class="upload-text__info">Click to upload or drag and drop JPG, JPEG & PNG (Max 30MB)</span><div>'
        );

        $('.icon-upload').attr('src', '/img/plus.svg').attr('alt', 'Icon upload');

        clearInterval(validView3);
      }
    }, 100);
  }

  clickDate() {
    const dates = document.querySelector('#date_of_birth').value;
    if (dates !== '') {
      $('#date_of_birth').css('color', '#000000');
    } else {
      $('#date_of_birth').css('color', '#8a8787');
    }
  }

  updated(changedProperties) {
    const valDate = setInterval(() => {
      if ($('#date_of_birth').length > 0) {
        this.addEventListener('click', this.clickDate);

        clearInterval(valDate);
      }
    }, 1000);

    const injectDateStyles = setInterval(() => {
      const dateComp = document.querySelector('#date_of_birth');
      if (dateComp && dateComp.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          input[type="date"] {
            width: 100% !important;
            height: 50px !important;
            background: #E7E7E7 !important;
            border-radius: 8px !important;
            border: 1px solid #C5C5C5 !important;
            padding: 0 12px !important;
            box-sizing: border-box !important;
            font-size: 14px !important;
            color: #A4A4A4 !important;
          }
        `;
        dateComp.shadowRoot.appendChild(style);
        clearInterval(injectDateStyles);
      }
    }, 200);

    if (changedProperties.has('_activePeriod') && this._activePeriod) {
      this.progId = this._activePeriod.formId;
      this.selectReceipt = {
        ...this.selectReceipt,
        programId: this._activePeriod.formId,
        idComponent: this._activePeriod.idComponent
      };
    }

    if (changedProperties.has('contentStrapi')) {
      this.requestUpdate();
    }
  }

  firstUpdated() {
    // Google Tag Manager
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-5CK423P2');

    const gtmNoscript = document.createElement('noscript');
    const gtmIframe = document.createElement('iframe');
    gtmIframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5CK423P2';
    gtmIframe.height = '0';
    gtmIframe.width = '0';
    gtmIframe.style.display = 'none';
    gtmIframe.style.visibility = 'hidden';
    gtmNoscript.appendChild(gtmIframe);
    document.body.insertBefore(gtmNoscript, document.body.firstChild);

    const image = this.renderRoot.querySelector('.img-slider-mobile');

    if (image !== null) {
      this._resizeObserver = new ResizeObserver(() => {
        this.imageHeight = image.clientHeight;
        this.requestUpdate();
      });

      this._resizeObserver.observe(image);
    }

    const interval = setInterval(() => {
      const inputs = document.querySelectorAll('component-text-email');

      if (inputs.length > 0) {
        const btn = this.querySelector('#btn-next');
        const input = document.querySelector('input[type="file"]');

        this.handlePdfUpload();

        document.querySelector('input[type="file"]').addEventListener(
          'change',
          async (e) => {
            this.handleCrooperZoom();
          },
          true
        );

        if (input) {
          input.setAttribute('data-required', 'true');
        }

        if (btn) {
          btn.addEventListener('click', this.handleSubmitBtn.bind(this));
        }

        clearInterval(interval);
      }
    }, 500);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._resizeObserver?.disconnect();
    clearTimeout(this._changeTimeout);
    clearInterval(this._safetyInterval);
  }

  _scheduleNextChange(config) {
    const ms = msUntilNextChange(config);
    if (ms === null) return;

    this._changeTimeout = setTimeout(() => {
      const newPeriod = resolveActivePeriod(config);
      if (newPeriod?.formId !== this._activePeriod?.formId) this._activePeriod = newPeriod;
      const ended = resolveCampaignEnded(config);
      if (ended !== this._campaignEnded) this._campaignEnded = ended;
      this._scheduleNextChange(config);
    }, ms);
  }

  // FUNCIONES QUE SIRVEN PARA EL HACK DE SUBIDA DE FACTURAS PDF Y ZOOM  =====================================================================================

  handleCrooperZoom() {
    const obs = new MutationObserver(() => {
      const container = document.querySelector('.cropper-container');
      if (!container) return;

      const img =
        document.querySelector('img.cropper-hidden') ||
        document.querySelector('#upload_receipt-image') ||
        container.querySelector('img');

      let instance = null;

      if (img && window.Cropper) {
        try {
          instance = window.Cropper.getInstance ? window.Cropper.getInstance(img) : img.cropper;
        } catch (e) {
          console.log(e);
          // Error al obtener instancia de Cropper, ignorar
        }
      }

      if (instance) {
        // No permitir mover ni redimensionar
        instance.setDragMode('none');
        instance.disable(); // Bloquea interacción

        const cropBox = container.querySelector('.cropper-crop-box');
        if (cropBox) {
          cropBox.style.pointerEvents = 'none';
        }

        // Capturar click en botones
        document.addEventListener('click', (e) => {
          const btn = e.target.closest('.btn-cropper');
          if (!btn) return;

          const imgIcon = btn.querySelector('img');
          const src = imgIcon?.src || '';

          if (src.includes('zoom-in')) {
            // console.log('Zoom In button clicked');
            instance.enable();
            instance.zoom(0.1);
            instance.disable();
          }

          if (src.includes('zoom-out')) {
            // console.log('Zoom Out button clicked');
            instance.enable();
            instance.zoom(-0.1);
            instance.disable();
          }

          if (src.includes('rotate-left')) {
            // console.log('Rotate Left button clicked');
            instance.enable();
            instance.rotate(-90);
            instance.disable();
          }

          if (src.includes('rotate-right')) {
            // console.log('Rotate Right button clicked');
            instance.enable();
            instance.rotate(90);
            instance.disable();
          }
        });

        const points = container.querySelectorAll('.cropper-point');
        points.forEach((p) => {
          p.style.display = 'none';
        });

        // Bloquear zoom por scroll PERO permitir por botón
        const originalZoom = instance.zoom;

        instance.zoom = function zoomOverride(ratio, event) {
          if (
            event &&
            (event.type === 'wheel' ||
              event.type === 'mousewheel' ||
              event.type === 'touchmove' ||
              event.type === 'gesturestart')
          ) {
            return false; // bloquear zoom por gestos
          }

          // Permitir zoom si viene de botón (click o sin evento)
          return originalZoom.call(this, ratio, event);
        };

        // 🔥 Permitir scroll del body normalmente
        container.addEventListener('wheel', () => {}, { passive: true });
        container.addEventListener('touchmove', () => {}, { passive: true });
      }

      obs.disconnect();
    });

    obs.observe(document.body, { childList: true, subtree: true });

    return null;
  }

  handleDeletePdf(e) {
    e.preventDefault();

    const input = document.querySelector('input[type="file"]');
    const wrapper = document.querySelector('.upload-btn-wrapper');
    const pdfImg = document.querySelector('.pdf-preview');

    if (wrapper) {
      wrapper.style.display = 'block';
    }

    pdfImg.style.display = 'none';
    input.value = '';
  }

  handlePdfUpload() {
    const input = document.querySelector('input[type="file"]');

    if (input) {
      input.setAttribute('accept', 'image/*,.pdf');

      input.addEventListener('change', (event) => {
        const file = event.target.files[0];

        if (!file) return;

        const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

        const component = event.target.closest('component-upload-file');
        const wrapper = component.querySelector('.upload-btn-wrapper');

        if (isPdf) {
          // 🔹 Ocultar botón upload
          if (wrapper) {
            wrapper.style.display = 'none';
          }

          // 🔹 Crear imagen solo si no existe
          let pdfImg = component.querySelector('.pdf-preview');

          if (!pdfImg) {
            // 🔥 Crear contenedor
            pdfImg = document.createElement('div');
            pdfImg.className = 'pdf-preview';
            pdfImg.style.width = '100%';
            pdfImg.style.maxWidth = '100%';
            pdfImg.style.display = 'block';

            // 🔥 Contenido interno (puedes modificarlo después)
            pdfImg.innerHTML = `
                <div class="pdf-preview-inner">
                  <img 
                    src="/dist/69cd762799a90b8f7efa4ed3/static/nopreview.png"
                    style="width: 100%; max-width: 100%"
                  />
                  <div class="contain-boton-crooper">
                    <button class="cropper-clear" id="upload_receipt-delete"><img src="/static/trash-can.svg" alt="Clear"></button>
                  </div>
                </div>
              `;

            component.appendChild(pdfImg);

            const btn = this.querySelector('#upload_receipt-delete');

            if (btn) {
              btn.addEventListener('click', this.handleDeletePdf.bind(this));
            }
          } else {
            pdfImg.style.display = 'block';
          }

          if (input) {
            // Forzarlo inicialmente
            input.setAttribute('validate-todo', 'false');

            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'validate-todo') {
                  const currentValue = input.getAttribute('validate-todo');

                  if (currentValue === 'true') {
                    console.log('Lo cambiaron a true, lo vuelvo a false 😎');
                    input.setAttribute('validate-todo', 'false');
                  }
                }
              });
            });

            observer.observe(input, {
              attributes: true,
              attributeFilter: ['validate-todo']
            });
          }
        }
      });
    }
  }

  async handleSubmitBtn(e) {
    const pdfImg = document.querySelector('.pdf-preview');
    const input = document.querySelector('input[type="file"]');

    if (input) {
      if (input.files.length === 0) {
        input.setAttribute('data-required', 'true');
        document.querySelector('#error-upload_receipt').style.display = 'block';
      } else {
        input.setAttribute('data-required', 'false');
      }
    }

    const hasFormErrors = Array.from(
      document.querySelectorAll('.input-error, .error-check-text')
    ).some((el) => getComputedStyle(el).display !== 'none');

    if (hasFormErrors) {
      // console.log('Hay errores ❌');
      return;
    }

    if (pdfImg) {
      imgData = await getCropped.getCropped(
        e,
        'https://api.helloprobability.io',
        `${this.selectReceipt.name}`,
        `${this.selectReceipt.programId}`,
        `${this.selectReceipt.idComponent}`,
        this.selectReceipt.maxSizeImg
      );

      if (imgData !== '') {
        console.log('Imagen procesada, preparando datos para envío...');
        this.dataEntries.upload_receipt = imgData;
        // console.log('con pdf', this.dataEntries);
        // console.log(this.dataEntries);
        this.handleSubmit();
      }
    }
  }

  // FUNCIONES QUE SIRVEN PARA EL HACK DE SUBIDA DE FACTURAS PDF Y ZOOM  =====================================================================================

  render() {
    const { contentStrapi, basepath, view } = this;

    if (this._campaignEnded) {
      return html`
        <div class="campaign-closed">
          <img
            class="campaign-closed__pattern"
            src="/dist/69cd762799a90b8f7efa4ed3/static/campaign-closed-bg.png"
            alt=""
          />
          <img
            class="campaign-closed__logo"
            src="/dist/69cd762799a90b8f7efa4ed3/static/campaign-closed-logo.svg"
            alt="Drumstick Summer Snackdown Sweepstakes"
          />
          <h1 class="campaign-closed__title">
            Thank you for your interest in the Drumstick Summer Snackdown Sweepstakes! The
            Sweepstakes is now closed. Follow us @Drumstick to stay up to date on the latest!
          </h1>
        </div>
      `;
    }

    let vistaPrevia = '';

    const { sliderInfo } = contentStrapi;

    const bg =
      contentStrapi.backgroundInfo !== null && contentStrapi.backgroundInfo.backgroundimage !== null
        ? String(contentStrapi.backgroundInfo.backgroundimage.url).replace('/uploads/', '')
        : null;

    if (view === 1) {
      vistaPrevia = html`
        <div class="thank-you">
          <img src="/dist/69cd762799a90b8f7efa4ed3/static/logo-header-1.png" class="cimg" />
          <h2>You’ve entered the ring. Now bring the heat! </h2>

          <p class="p1">
            Thanks for joining the Drumstick Summer Snackdown Sweepstakes. With monthly prize drops
            and a $10,000 grand prize on the line, it’s time to snack, scan, and repeat.
          </p>

          <h2>Want more chances to win?</h2>

          <p class="p2">
            Share your entry on
            <a
              href="https://x.com/drumstick"
              target="_blank"
              @click=${() => this.bonusEntry('twitter')}
              >X</a
            >
            ,
            <a
              href="https://www.facebook.com/drumstick"
              target="_blank"
              @click=${() => this.bonusEntry('facebook')}
              >Facebook</a
            >
            ,
            <a
              href="https://www.instagram.com/drumstick"
              target="_blank"
              @click=${() => this.bonusEntry('instagram')}
              >Instagram</a
            >
            , and
            <a
              href="https://www.tiktok.com/@drumstick"
              target="_blank"
              @click=${() => this.bonusEntry('tiktok')}
              >TikTok</a
            >
            and score bonus entries!
          </p>

          <h2>Champions don’t stop at one entry. See you back here soon.</h2>
        </div>
      `;
    }

    if (view === 2) {
      vistaPrevia = html`
        <div class="thank-you">
          <img src="/dist/69cd762799a90b8f7efa4ed3/static/logo-header-1.png" class="cimg" />
          <h2 class="rh1"></h2>
        </div>
      `;
    }

    return html`
      <div id="container" class="home container">
        <div
          class="container-left invisible-scrollbars"
          style="${contentStrapi.backgroundInfo !== null &&
          contentStrapi.backgroundInfo.backgroundimage !== null
            ? `background-image: url('${basepath}/dist/${contentStrapi.programId}/img/${bg}'), linear-gradient(180deg, #204EAC 0%, #00C3E7 50.48%, #204EAC 98.56%);`
            : null}"
        >
          <div class="slidermobile-component">
            <section class="your-class">
              ${(sliderInfo.imageslidermb?.length ?? 0) > 0
                ? sliderInfo.imageslidermb.map(
                    (item) =>
                      html`<img
                        src=${`${String(`${basepath}/dist/${contentStrapi.programId}/img/${item.url}`).replace('/uploads/', '')}`}
                        class="img-slider-mobile"
                        alt="${item.alternativeText}"
                      />`
                  )
                : html`
                    <div>
                      <span style="position: absolute; font-size: 20px; color:rgb(123, 122, 122);"
                        >1024 x 500</span
                      >
                    </div>
                  `}
            </section>
          </div>

          <div class="container-left-scrollbars invisible-scrollbars">
            <div class="blurred"></div>

            <!--Section Header-->
            <header-webcomponent
              .data="${contentStrapi.headerInfo}"
              .basepath="${basepath}"
              .program_id=${contentStrapi.programId}
            ></header-webcomponent>

            <!--Section Promotion Description-->
            <information-webcomponent .data="${contentStrapi.homeInfo}"></information-webcomponent>

            <!--Section Form-->
            <form-webcomponent
              .data="${contentStrapi.formInfo}"
              .activeFormId="${this._activePeriod?.formId}"
            ></form-webcomponent>

            ${vistaPrevia}

            <!--Section prize-->
            ${contentStrapi.prizeInfo !== null && contentStrapi.prizeInfo.activePrize
              ? html` <prize-webcomponent
                  .data="${contentStrapi.prizeInfo}"
                  .basepath="${basepath}"
                  .program_id=${contentStrapi.programId}
                ></prize-webcomponent>`
              : null}

            <!-- More Info Section -->
            <moreinfo-webcomponent></moreinfo-webcomponent>

            <!--Section AbRules-->
            <abrules-webcomponent .data="${contentStrapi.abRulesInfo}"></abrules-webcomponent>

            <!-- <div class="social" aria-label="Social Media Links">
              <a target="_blank" href="https://www.tiktok.com/@drumstick"><img src="/dist/69cd762799a90b8f7efa4ed3/static/tiktok.svg" alt="TikTok icon" class="social-icon"></a>
              <a target="_blank" href="https://www.instagram.com/drumstick"><img src="/dist/69cd762799a90b8f7efa4ed3/static/instagram.svg" alt="Instagram icon" class="social-icon"></a>
              <a target="_blank" href="https://www.facebook.com/drumstick"><img src="/dist/69cd762799a90b8f7efa4ed3/static/facebook.svg" alt="Facebook icon" class="social-icon"></a>
              <a target="_blank" href="https://x.com/drumstick"><img src="/dist/69cd762799a90b8f7efa4ed3/static/twitter.svg" alt="Twitter X icon" class="social-icon"></a>
            </div> -->

            <!--Section Footer-->
            <footer-webcomponent
              .data=${contentStrapi.footerInfo}
              .basepath="${basepath}"
              .program_id=${contentStrapi.programId}
            ></footer-webcomponent>

            <div class="blurred2"></div>
          </div>

          <div class="more-content-container">
            <img class="bounce" src="/img/arrow_scroll.svg" alt="Scroll Down" />
            <div class="blurred2"></div>
          </div>
        </div>

        <div class="container-right" style="width: 100%; overflow: hidden">
          <section class="your-class">
            ${(sliderInfo.imagesliderdk?.length ?? 0) > 0
              ? sliderInfo.imagesliderdk.map(
                  (item) => html`
                    <img
                      style="height: 100vh; width: 100%;"
                      src=${`${String(`${basepath}/dist/${contentStrapi.programId}/img/${item.url}`).replace('/uploads/', '')}`}
                      alt="${item.alternativeText}"
                    />
                  `
                )
              : html`
                  <div
                    style="height: 100vh; background-color:rgb(143, 143, 143); font-size: 60px; display: flex; justify-content: center; align-items: center; color: #9e9e9e; width: 100%"
                  >
                    720 x 900
                  </div>
                `}
          </section>
        </div>
      </div>
    `;
  }
}

customElements.define('lateral-gallery', LateralGallery);
